import { withTranslation } from 'react-i18next'
import Refresh from './Refresh'

export default withTranslation()(Refresh)
